import { render, staticRenderFns } from "./UpgradeTermsAndConditionsForNanoCustomers.vue?vue&type=template&id=605b73a2&scoped=true&"
import script from "./UpgradeTermsAndConditionsForNanoCustomers.vue?vue&type=script&lang=js&"
export * from "./UpgradeTermsAndConditionsForNanoCustomers.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeTermsAndConditionsForNanoCustomers.vue?vue&type=style&index=0&id=605b73a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605b73a2",
  null
  
)

export default component.exports